import React, { memo, useEffect } from 'react';
import { Paper } from '@app/components';
import { Button } from 'components/ui/button';
import useNcaLayer, { DN } from 'libs/NcaLayer/hooks';
import { IconFilePlus24 } from '@app/icons';

interface Props {
  onChange: (dn: DN) => void;
}

function NCALayer(props: Props) {
  const { onChange } = props;
  const { connected, chooseCertificate, isExpired, dn } = useNcaLayer();

  useEffect(() => {
    if (Object.keys(dn).length > 0) {
      onChange(dn);
    }
  }, [onChange, dn]);

  return (
    <Paper>
      <div className="flex flex-col gap-4 p-4">
        {isExpired && (
          <p className="text-sm text-destructive">
            Срок действия сертификата ЭЦП истек. Вам необходимо получить новый
            сертификат ЖЦП
          </p>
        )}
        {!connected ? (
          <p className="text-sm text-muted-foreground">NcaLayer не подключен</p>
        ) : (
          <Button
            variant="outline"
            className="flex items-center gap-2"
            onClick={chooseCertificate}
            type="button"
          >
            <IconFilePlus24 />
            <span>Выбрать сертификат ЭЦП</span>
          </Button>
        )}
      </div>
    </Paper>
  );
}

export default memo(NCALayer);
